import { Spin } from 'antd';
import { BtlBaseForm } from '../BtlBaseForm';
import { financingFormSchema } from './formSchema';
import { useFinancingAndPropertyForm } from './useFinancingAndPropertyForm';

export function Financing() {
  const form = useFinancingAndPropertyForm({
    formName: 'financing',
    getFormSchema: financingFormSchema,
  });

  if (form.isLoading) {
    return <Spin size='large' />;
  }

  return <BtlBaseForm {...form.formProps} />;
}

export default Financing;
